import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './types/hooks';
import moment from 'moment';
import { isLoggedIn$, language$, setReLoggedIn } from './store/slices/user';
import i18n from './i18n';
import { getUser } from './store/actions/userActions';
import { getDevicesCombined } from './store/actions/deviceActions';
import Sockets from './components/Sockets';
import { setSetDeviceUniqueId } from './store/slices/settings';
import { generateRandomHash } from './utils/hash';
// import { getAllCommands } from './store/actions/hunterActions';
// import { getNotifications } from './store/actions/notificationActions';

const AppWrapper = () => {
    const d = useAppDispatch();
    const language = useAppSelector(language$);
    const isLoggedIn = useAppSelector(isLoggedIn$);
    const deviceUniqueId = useAppSelector((s) => s.settings.deviceUniqueId);

    requireLocale(language);

    useEffect(() => {
        i18n.changeLanguage(language);
        requireLocale(language);
        moment.locale(language);
    }, [language]);

    useEffect(() => {
        const getDeviceId = async () => {
            const uniqueId = generateRandomHash();

            d(setSetDeviceUniqueId(uniqueId));
        };

        if (!deviceUniqueId) {
            getDeviceId();
        }
    }, []);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        try {
            d(getUser());
            // d(getPois());
            // d(getAllGeofences());
            // d(getDogGeofences());
            d(getDevicesCombined());
            // d(getAllCommands());
            // d(getNotifications());
        } catch (error) {
            console.log('Error', error);
        }

        return () => {
            d(setReLoggedIn(-1));
            // d(relogIn());
        };
    }, [isLoggedIn]);

    return <Sockets />;
};

export default AppWrapper;

export const requireLocale = (lng: string) => {
    switch (lng) {
        case 'sv':
            require('moment/locale/sv');
            break;
        case 'en':
            require('moment');
            break;
        case 'fr':
            require('moment/locale/fr');
            break;
        case 'de':
            require('moment/locale/de');
            break;
        case 'pl':
            require('moment/locale/pl');
            break;
        case 'it':
            require('moment/locale/it');
            break;
        case 'fi':
            require('moment/locale/fi');
            break;
        case 'el':
            require('moment/locale/el');
            break;
        case 'es':
            require('moment/locale/es');
            break;
        case 'no':
            require('moment/locale/nb');
            break;
        case 'da':
            require('moment/locale/da');
            break;
        default:
            require('moment');
            break;
    }
};
